module.exports = __webpack_public_path__ + "355768ef9ebe6784f3aa9fea46e2413a.svg";